import React, {useEffect} from 'react'
import {useNavigate} from "react-router";

export const Redirect = ({ to, replace }) => {
  let navigate = useNavigate();
  useEffect(() => {
    navigate(to, { replace: replace });
  });
  return null;
}